module.exports = __webpack_public_path__ + "static/media/scythe.f0a97d33.svg";